module.exports = __webpack_public_path__ + "img/ARCH-alt.f9f8bd5b.svg";